module.exports = __webpack_public_path__ + "media/images/avatar/1-6cdfc7189d5c06ee13149293461f6f49.svg";